export const VIEW_DEPENDENCIES = 'state.ui.main.tabs.dependencies.VIEW_DEPENDENCIES' as const;
export const CLICK_DEPENDENCY_CARD =
	'state.ui.main.tabs.dependencies.CLICK_DEPENDENCY_CARD' as const;
export const CLICK_DEPENDENCY_LINE =
	'state.ui.main.tabs.dependencies.CLICK_DEPENDENCY_LINE' as const;

export type ViewDependenciesAction = {
	type: typeof VIEW_DEPENDENCIES;
};

export type ClickDependencyLineAction = {
	type: typeof CLICK_DEPENDENCY_LINE;
	payload: {
		linksLength: number;
	};
};

export type ClickDependencyCardAction = {
	type: typeof CLICK_DEPENDENCY_CARD;
	payload: {
		id: string;
	};
};

export const viewDependencies = (): ViewDependenciesAction => ({
	type: VIEW_DEPENDENCIES,
});

export const clickDependencyCard = (id: string): ClickDependencyCardAction => ({
	type: CLICK_DEPENDENCY_CARD,
	payload: {
		id,
	},
});

export const clickDependencyLine = (linksLength: number): ClickDependencyLineAction => ({
	type: CLICK_DEPENDENCY_LINE,
	payload: {
		linksLength,
	},
});
